// The Sales Hold phone call's safe-to-call box (2026-10-12): three states from
// the step's own params.callTimeStatus. 'unknown' (no time zone resolved) is
// warning orange, never the red "Not Safe" that a resolved zone outside the
// window gets. A suggestion from before callTimeStatus existed renders from
// params.safeToCall, as it always did.
export function callTimeDisplay(params) {
  const status = params?.callTimeStatus ?? (params?.safeToCall ? 'safe' : 'not_safe')
  if (status === 'safe') return { status, text: 'Safe to Call', color: 'success.main' }
  if (status === 'unknown') return { status, text: 'Unable to confirm if safe to call, please check customer time zone', color: 'warning.main' }
  return { status: 'not_safe', text: 'Not Safe To Call Yet', color: 'error.main' }
}
